/**
 * Admin Useraccount API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserDto } from './userDto';


export interface AccessDto { 
    id?: number;
    user?: UserDto;
    scope?: AccessDto.ScopeEnum;
}
export namespace AccessDto {
    export const ScopeEnum = {
        AdminUserAccountRead: 'ADMIN_USER_ACCOUNT_READ',
        AdminUserAccountWrite: 'ADMIN_USER_ACCOUNT_WRITE',
        BackofficeSales: 'BACKOFFICE_SALES',
        OofRead: 'OOF_READ',
        OofWrite: 'OOF_WRITE',
        DeviceRegistration: 'DEVICE_REGISTRATION',
        WildlifeRead: 'WILDLIFE_READ',
        WildlifeUpload: 'WILDLIFE_UPLOAD',
        AirtimesRead: 'AIRTIMES_READ',
        AirtimesWrite: 'AIRTIMES_WRITE',
        DevicesRead: 'DEVICES_READ',
        DevicesManage: 'DEVICES_MANAGE',
        DevicesAdmin: 'DEVICES_ADMIN',
        CommandsRead: 'COMMANDS_READ',
        CommandsWrite: 'COMMANDS_WRITE',
        RoofTest: 'ROOF_TEST',
        HardwareRead: 'HARDWARE_READ',
        HardwareWrite: 'HARDWARE_WRITE',
        UserRead: 'USER_READ',
        UserWrite: 'USER_WRITE',
        Statistics: 'STATISTICS',
        ProviderMessages: 'PROVIDER_MESSAGES',
        MicroserviceControl: 'MICROSERVICE_CONTROL',
        ManufacturingRead: 'MANUFACTURING_READ',
        ManufacturingWrite: 'MANUFACTURING_WRITE',
        ManufacturingAdmin: 'MANUFACTURING_ADMIN'
    } as const;
    export type ScopeEnum = typeof ScopeEnum[keyof typeof ScopeEnum];
}


export type ScopeEnum = typeof AccessDto.ScopeEnum[keyof typeof AccessDto.ScopeEnum];
